const $$splitComponentImporter = () => import('/Users/vthang/projects/marvy/marvy_mono/apps/pinktool/src/routes/_app/admin.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import "react-datepicker/dist/react-datepicker.css";
export const Route = createFileRoute("/_app/admin")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
// Stats Card Component
interface StatsCardProps {
  title: string;
  value: string;
  icon: React.ReactNode;
  color: "blue" | "green" | "orange" | "purple";
}
// Chart Card Component
interface ChartCardProps {
  title: string;
  children: React.ReactNode;
}